import React from "react";
import { CustomChip } from "../CustomChip";

interface ILeadStatusProps {
  status: string;
  actualStatus?: string;
}

export const LeadStatusRenderer: React.FC<ILeadStatusProps> = (props) => {
  const capitalizeFirstLetter = (text: string): string => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  const status = (props.status || "").toLowerCase();
  const actualStatus = (props.actualStatus || "").toLowerCase();
  if (status === "ongoing" || actualStatus === "ongoing") {
    return (
      <CustomChip
        content={status ? capitalizeFirstLetter(status) : "--"}
        size="small"
        sx={{ color: "#ff8c03", bgcolor: "#fff1e0" }}
      />
    );
  } else if (status === "dead" || actualStatus === "dead") {
    return (
      <CustomChip
        color="error"
        content={status ? capitalizeFirstLetter(status) : "--"}
        size="small"
        sx={{ color: "#fff" }}
      />
    );
  } else if (status === "cancelled" || actualStatus === "cancelled") {
    return (
      <CustomChip
        color="error"
        content={status ? capitalizeFirstLetter(status) : "--"}
        size="small"
        sx={{ color: "#fff" }}
      />
    );
  } else if (status === "booked" || actualStatus === "booked") {
    return (
      <CustomChip
        color="success"
        content={status ? capitalizeFirstLetter(status) : "--"}
        size="small"
      />
    );
  } else if (status === "postponed" || actualStatus === "postponed") {
    return (
      <CustomChip
        color="info"
        content={status ? capitalizeFirstLetter(status) : "--"}
        size="small"
      />
    );
  } else {
    return <CustomChip color="primary" content={status || "--"} size="small" />;
  }
};
